/**
 * Do not edit directly
 * Generated on Fri, 28 Feb 2025 07:31:33 GMT
 */

export const balColorBackgroundPrimary = "#000d6e"; // Blue is our accent color and it is present on every touchpoint. Our logo, text, buttons and links are blue.
export const balColorBackgroundGreenLight = "#e9fbf7"; // Default brand background color to use
export const balColorBackgroundGreen = "#94e3d4"; // Use this background for call to action sections
export const balColorBackgroundPurpleLight = "#f9f3ff"; // Default brand background color to use
export const balColorBackgroundPurple = "#b8b2ff"; // Use this background for call to action sections
export const balColorBackgroundYellowLight = "#fff9e8"; // Default brand background color to use
export const balColorBackgroundYellow = "#fae052"; // Use this background for call to action sections
export const balColorBackgroundRedLight = "#ffeef1"; // Default brand background color to use
export const balColorBackgroundRed = "#ffaca6"; // Use this background for call to action sections
export const balColorBackgroundWhite = "#ffffff";
export const balColorBackgroundGreyLight = "#f6f6f6";
export const balColorBackgroundGrey = "#e8e8e8";
export const balColorBackgroundDisabled = "#e8e8e8";
export const balColorBackgroundInfo = "#60a0e0";
export const balColorBackgroundSuccess = "#5bab7a";
export const balColorBackgroundWarning = "#ffd25e";
export const balColorBackgroundDanger = "#f05d4d";
export const balColorBorder = "#e8e8e8"; // Default border color
export const balColorBorderPrimary = "#000d6e"; // Use for focused or selected state.
export const balColorBorderPrimaryLight = "#656ea8"; // Disabled or secondary color on dark backgrounds
export const balColorBorderGreyLight = "#f6f6f6"; // Default input color or can be use for a divider
export const balColorBorderGrey = "#e8e8e8"; // Default border color
export const balColorBorderGreyDark = "#b6b6b6"; // Use for disabled state.
export const balColorBorderWhite = "#ffffff"; // Default color on dark backgrounds.
export const balColorBorderInfo = "#1c77d2";
export const balColorBorderSuccess = "#168741"; // Use for valid state.
export const balColorBorderWarning = "#f99319"; // Use for warning/hint state.
export const balColorBorderDanger = "#ea1800"; // Use for invalid state.
export const balColorBorderInfoHovered = "#155ba3";
export const balColorBorderInfoPressed = "#0e457b";
export const balColorBorderPrimaryHovered = "#0014aa";
export const balColorBorderPrimaryPressed = "#000739";
export const balColorBorderSuccessHovered = "#116b34";
export const balColorBorderSuccessPressed = "#0b5227";
export const balColorBorderWarningHovered = "#f99319";
export const balColorBorderWarningPressed = "#c97612";
export const balColorBorderDangerHovered = "#cb1501";
export const balColorBorderDangerPressed = "#a01100";
export const balColorBorderGreenHovered = "#00b28f";
export const balColorBorderGreenPressed = "#1b5951";
export const balColorBorderPurpleHovered = "#9f52cc";
export const balColorBorderPurplePressed = "#6c2273";
export const balColorBorderRedHovered = "#d9304c";
export const balColorBorderRedPressed = "#99172d";
export const balColorBorderYellowHovered = "#fa9319";
export const balColorBorderYellowPressed = "#b24a00";
export const balColorBorderInverted = "#ffffff"; // Default color on dark backgrounds.
export const balColorBorderInvertedDisabled = "#656ea8"; // Disabled.
export const balColorBorderInvertedPrimary = "#293485";
export const balColorBorderInvertedPrimaryHovered = "#a7d1fa";
export const balColorBorderInvertedPrimaryPressed = "#6672cc";
export const balColorPrimary = "#000d6e";
export const balColorGrey = "#e8e8e8";
export const balColorLightBlue = "#e5f1fe";
export const balColorPurple = "#b8b2ff";
export const balColorGreen = "#94e3d4";
export const balColorYellow = "#fae052";
export const balColorRed = "#ffaca6";
export const balColorInfo = "#60a0e0";
export const balColorSuccess = "#5bab7a";
export const balColorWarning = "#ffd25e";
export const balColorDanger = "#f05d4d";
export const balColorPrimary1 = "#e5e7f0";
export const balColorPrimary2 = "#b3b6d4";
export const balColorPrimary3 = "#656ea8";
export const balColorPrimary4 = "#293485";
export const balColorPrimary5 = "#000d6e";
export const balColorPrimary6 = "#000739";
export const balColorWhite = "#ffffff";
export const balColorGreen1 = "#e9fbf7";
export const balColorGreen2 = "#cbf2ec";
export const balColorGreen3 = "#94e3d4";
export const balColorGreen4 = "#21d9ac";
export const balColorGreen5 = "#00b28f";
export const balColorGreen6 = "#1b5951";
export const balColorPurple1 = "#f9f3ff";
export const balColorPurple2 = "#e1d9ff";
export const balColorPurple3 = "#b8b2ff";
export const balColorPurple4 = "#be82fa";
export const balColorPurple5 = "#9f52cc";
export const balColorPurple6 = "#6c2273";
export const balColorYellow1 = "#fff9e8";
export const balColorYellow2 = "#ffecbc";
export const balColorYellow3 = "#fae052";
export const balColorYellow4 = "#ffbe19";
export const balColorYellow5 = "#fa9319";
export const balColorYellow6 = "#b24a00";
export const balColorRed1 = "#ffeef1";
export const balColorRed2 = "#ffd7d7";
export const balColorRed3 = "#ffaca6";
export const balColorRed4 = "#ff596f";
export const balColorRed5 = "#d9304c";
export const balColorRed6 = "#99172d";
export const balColorGrey1 = "#fafafa";
export const balColorGrey2 = "#f6f6f6";
export const balColorGrey3 = "#e8e8e8";
export const balColorGrey4 = "#b6b6b6";
export const balColorGrey5 = "#747474";
export const balColorGrey6 = "#313131";
export const balColorBlack = "#000000";
export const balColorLightBlue1 = "#e5f1fe";
export const balColorLightBlue2 = "#a7d1fa";
export const balColorLightBlue3 = "#56a7f5";
export const balColorLightBlue4 = "#6672cc";
export const balColorLightBlue5 = "#0014aa";
export const balColorLightBlue6 = "#000a55";
export const balColorInfo1 = "#e8f1fb";
export const balColorInfo2 = "#a4c9ed";
export const balColorInfo3 = "#60a0e0";
export const balColorInfo4 = "#1c77d2";
export const balColorInfo5 = "#155ba3";
export const balColorInfo6 = "#0e457b";
export const balColorSuccess1 = "#e8f3ec";
export const balColorSuccess2 = "#a1cfb3";
export const balColorSuccess3 = "#5bab7a";
export const balColorSuccess4 = "#168741";
export const balColorSuccess5 = "#116b34";
export const balColorSuccess6 = "#0b5227";
export const balColorWarning1 = "#fff9e8";
export const balColorWarning2 = "#ffe5a3";
export const balColorWarning3 = "#ffd25e";
export const balColorWarning4 = "#ffbe19";
export const balColorWarning5 = "#f99319";
export const balColorWarning6 = "#c97612";
export const balColorDanger1 = "#fce8e6";
export const balColorDanger2 = "#f7a299";
export const balColorDanger3 = "#f05d4d";
export const balColorDanger4 = "#ea1800";
export const balColorDanger5 = "#cb1501";
export const balColorDanger6 = "#a01100";
export const balColorShadowFocusStart = "#ffffff";
export const balColorShadowFocusEnd = "#6c2273";
export const balColorShadowFocusInvertedStart = "#ffffff";
export const balColorShadowFocusInvertedEnd = "#fae052";
export const balColorTextPrimary = "#000d6e"; // Main font color for all headings and paragraphs.
export const balColorTextPrimaryLight = "#656ea8"; // Secondary font color for help messages.
export const balColorTextWhite = "#ffffff"; // Main font color for all headings and paragraphs on a dark background.
export const balColorTextGreyLight = "#b6b6b6"; // Font color for disabled texts
export const balColorTextGrey = "#747474"; // Font color for placeholders
export const balColorTextGreyDark = "#313131"; // Font color for disabled elements
export const balColorTextInfo = "#1c77d2";
export const balColorTextWarning = "#f99319";
export const balColorTextSuccess = "#168741";
export const balColorTextDanger = "#ea1800";
export const balColorTextBlack = "#000000";
export const balColorTextPrimaryHovered = "#0014aa";
export const balColorTextPrimaryPressed = "#000739";
export const balColorTextDangerHovered = "#cb1501";
export const balColorTextDangerPressed = "#a01100";
export const balColorTextInverted = "#ffffff";
export const balColorTextInvertedDisabled = "#656ea8";
export const balColorTextInvertedHovered = "#a7d1fa";
export const balColorTextInvertedPressed = "#60a0e0";
export const balBorderWidthSmall = "0.063rem"; // The small border size is crafted for subtle, refined delineation.
export const balBorderWidthNormal = "0.125rem"; // The normal border size strikes a harmonious balance, offering a versatile choice for defining boundaries within your design.
export const balBorderWidthLarge = "0.25rem"; // The large border size makes a bold statement, creating strong visual contrasts and emphasizing key elements within your interface.
export const balBreakpointTablet = "769px"; // Tailored for tablet devices, this breakpoint ensures a seamless and optimized user experience on medium-sized screens.
export const balBreakpointDesktop = "1024px"; // Optimized for desktop screens, this breakpoint provides a spacious canvas for your design, allowing for more intricate layouts and detailed content presentation.
export const balBreakpointHighDefinition = "1280px"; // Designed for high-definition displays, this breakpoint elevates your interface to a level of visual richness and clarity.
export const balBreakpointWidescreen = "1440px"; // Tailored for widescreen monitors, this breakpoint offers a panoramic view that accommodates expansive content layouts.
export const balBreakpointFullhd = "1920px"; // Crafted for Full HD displays, this breakpoint strikes a balance between detail and performance.
export const balContainerSizeDetailPage = "744px"; // Deprecated container size for the website
export const balContainerSizeCompact = "896px"; // Tailored container size designed for form wizard applications or pages.
export const balContainerSizeNormal = "1496px"; // The default container size is versatile and suitable for various applications and website pages.
export const balContainerSizeFluid = "100%"; // The container for fullscreen application with a large table for example.
export const balContainerSpace = "1rem"; // Default space of a container to left and right side.
export const balContainerSpaceTablet = "2.5rem"; // Default space on tablets of a container to left and right side.
export const balContainerSpaceDesktop = "3rem"; // Default space on desktops of a container to left and right side.
export const balColumnGap = "1rem";
export const balRadiusNormal = "0.25rem"; // The normal radius token strikes a balance between softness and structure.
export const balRadiusLarge = "0.75rem"; // The large radius token makes a bold visual statement by significantly rounding the corners of elements.
export const balRadiusRounded = "9999px"; // The rounded radius token embraces a curvier design language, introducing a high degree of softness and fluidity to your elements.
export const balSpaceXxSmall = "0.25rem"; // Minimum space between two elements
export const balSpaceXxSmallTablet = "0.25rem";
export const balSpaceXxSmallDesktop = "0.25rem";
export const balSpaceXSmall = "0.5rem"; // Space between text and icons or headings and content or clickable elements
export const balSpaceXSmallTablet = "0.5rem";
export const balSpaceXSmallDesktop = "0.5rem";
export const balSpaceSmall = "0.75rem";
export const balSpaceSmallTablet = "0.75rem";
export const balSpaceSmallDesktop = "0.75rem";
export const balSpaceNormal = "1rem"; // Space between large headings and content.
export const balSpaceNormalTablet = "1rem";
export const balSpaceNormalDesktop = "1rem";
export const balSpaceMedium = "1.25rem"; // Inner padding of cards
export const balSpaceMediumTablet = "1.25rem";
export const balSpaceMediumDesktop = "1.5rem";
export const balSpaceLarge = "1.5rem"; // Space between cards
export const balSpaceLargeTablet = "1.5rem";
export const balSpaceLargeDesktop = "2rem";
export const balSpaceXLarge = "2rem"; // Space between heading and card
export const balSpaceXLargeTablet = "2.5rem";
export const balSpaceXLargeDesktop = "3rem";
export const balSpaceXxLarge = "3rem";
export const balSpaceXxLargeTablet = "3.5rem";
export const balSpaceXxLargeDesktop = "4rem";
export const balSpaceXxxLarge = "3.5rem"; // Footer bottom padding
export const balSpaceXxxLargeTablet = "4.5rem";
export const balSpaceXxxLargeDesktop = "6rem";
export const balSpaceXxxxLarge = "4rem"; // Space between sections
export const balSpaceXxxxLargeTablet = "6rem";
export const balSpaceXxxxLargeDesktop = "8rem";
export const balFontWeightBold = "700"; // Bold is used for headings, links and buttons.
export const balFontWeightRegular = "400"; // Default width of paragraphs. Only available with the font BaloiseCreateText.
export const balFontWeightLight = "300"; // Can be used for secondary headings. Only available with the font BaloiseCreateHeadline.
export const balTextSizeXSmall = "0.75rem"; // Should only be used for helper texts or validation messages of a form control.
export const balTextSizeXSmallTablet = "0.75rem";
export const balTextSizeXSmallDesktop = "0.75rem";
export const balTextSizeSmall = "0.875rem"; // Should only be used for label texts.
export const balTextSizeSmallTablet = "0.875rem";
export const balTextSizeSmallDesktop = "0.875rem";
export const balTextSizeNormal = "1rem"; // Should only be used for label texts.
export const balTextSizeNormalTablet = "1rem";
export const balTextSizeNormalDesktop = "1rem";
export const balTextSizeMedium = "1rem"; // Should only be used in a 2/3 grid column to improve readability.
export const balTextSizeMediumTablet = "1.125rem";
export const balTextSizeMediumDesktop = "1.125rem";
export const balTextSizeLarge = "1.125rem"; // Should only be used for standard card titles and headings of level 4 or for lead text/paragraphs after a heading.
export const balTextSizeLargeTablet = "1.25rem";
export const balTextSizeLargeDesktop = "1.25rem";
export const balTextSizeXLarge = "1.25rem"; // Should only be used for form titles, quick link navigation's and headings of level 3.
export const balTextSizeXLargeTablet = "1.5rem";
export const balTextSizeXLargeDesktop = "1.5rem";
export const balTextSizeXxLarge = "1.5rem"; // Should only be used for content titles and headings of level 2.
export const balTextSizeXxLargeTablet = "2rem";
export const balTextSizeXxLargeDesktop = "2rem";
export const balTextSizeXxxLarge = "1.75rem"; // Should only be used for stage titles and headings of level 1.
export const balTextSizeXxxLargeTablet = "2.5rem";
export const balTextSizeXxxLargeDesktop = "2.5rem";
export const balTextSizeXxxxLarge = "2rem"; // Should only be uses to illustrate large stage areas.
export const balTextSizeXxxxLargeTablet = "3rem";
export const balTextSizeXxxxLargeDesktop = "3rem";
export const balTextSizeXxxxxLarge = "3rem"; // Should only be uses to illustrate large stage areas.
export const balTextSizeXxxxxLargeTablet = "5rem";
export const balTextSizeXxxxxLargeDesktop = "5rem";
export const balTextLineHeightTitle = "1.3"; // Standard line-height for the headings.
export const balTextLineHeightText = "1.5"; // Default line height for all text elements.
export const balZIndexDeep = "-999999"; // Deep z-index is used to stack something behind everything else.
export const balZIndex = "1"; // The default z-index for components and elements inside components.
export const balZIndexMasked = "100"; // Default z-index for masked interface elements.
export const balZIndexMask = "200"; // Default z-index for masking interface elements.
export const balZIndexSticky = "300"; // Default z-index for sticky interface elements.
export const balZIndexNavigation = "400"; // Default z-index for navigation.
export const balZIndexPopup = "1000"; // Default z-index for popups that stacks on top of all other elements.
export const balZIndexModal = "1100"; // Default z-index for modals that stacks on top of overlays and other elements, but still allows popups to be visible.
export const balZIndexToast = "1200"; // Default z-index for toast and snackbar messages.
export const balZIndexTooltip = "1300"; // Default z-index for tooltips.
export const balAnimationTransitionDuration = "300ms";
export const balAnimationTransitionEasing = "cubic-bezier(0.25, 0.8, 0.5, 1)";
export const balShadowSmall = "0px 2px 5px 1px rgba(0, 7, 57, 0.12)";
export const balShadowNormal = "0 0 10px 0 rgba(0, 7, 57, 0.15)"; // Default shadow size to elevate an element.
export const balShadowLarge = "0 0 30px 0 rgba(0, 7, 57, 0.15)"; // Large shadow are used for hover effects.
export const balShadowHeader = "0 4px 4px 0 rgba(0, 7, 57, 0.15)"; // Shadow effect for a header bar
export const balFontFamilyTitle = "BaloiseCreateHeadline, Arial, sans-serif";
export const balFontFamilyText = "BaloiseCreateText, Arial, sans-serif";
export const balOpacity0 = "0";
export const balOpacity30 = "0.3";
export const balOpacity40 = "0.4";
export const balOpacity50 = "0.5";
export const balOpacity60 = "0.6";
export const balOpacity80 = "0.8";
export const balOpacity100 = "1";
export const balTextShadowNormal = "0px 0px 4px rgba(0, 0, 0, 0.15), 0px 4px 12px rgba(0, 0, 0, 0.25), 0px 0px 80px rgba(0, 0, 0, 0.5)"; // Increases readability when used on a image background.
